<template>
  <UsersTable
    :users="filteredUsers"
    :items="filteredUsers"
    :total-count="total"
    :unique-users="uniqueUsersList"
    :group-list="groupList"
    @update-user-table="loadData"
    @update-page="loadPage"
    @update-search="updateSearch"
  />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import UsersTable from '@/components/Users/UsersTable'
import { useStore } from 'vuex'

const store = useStore()

const page = ref(1)
let filters = ref({})

const filteredUsers = computed(() => store.getters['user/allFilteredUsers'])
const uniqueUsersList = computed(() => store.getters['user/allUniqueUsersList'])
const total = computed(() => store.getters['user/totalCount'])

const groupList = computed(() => store.getters['group/group'])
async function loadPage(page) {
  try {
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters?.value ?? {}).filter(([key, value]) => value != null),
    )

    let params = {}
    Object.keys(cleanedFilters)?.forEach((field) => {
      if (cleanedFilters[field]) {
        params[`filter[${field}]`] = cleanedFilters[field]
      }
    })
    const data = {
      page: page,
      pageSize: 20,
      ...params,
    }

    await store.dispatch('user/getUsers', data)
  } catch (err) {
    console.error(err)
  }
}

async function loadData(customPage = 1, pageSize = 20, filters) {
  const cleanedFilters = Object.fromEntries(
    Object.entries(filters?.value ?? {}).filter(([key, value]) => value != null),
  )

  let params = {}
  Object.keys(cleanedFilters)?.forEach((field) => {
    if (cleanedFilters[field]) {
      params[`filter[${field}]`] = cleanedFilters[field]
    }
  })
  const data = {
    page: customPage,
    pageSize: pageSize,
    ...params,
  }

  await store.dispatch('user/getUsers', data)
}

async function updateSearch(field, value) {
  filters.value[field] = value

  try {
    await loadData(page.value, 20, filters)
  } catch (err) {
    console.error(err)
  }
}

onMounted(async () => {
  await store.dispatch('group/getGroupSystem')
  loadData()
})
</script>
<script>
export default {
  name: 'UsersAndRolesView',
}
</script>
